module.exports = {
	"name": "react-svg-bar-chart",
	"version": "1.0.0",
	"author": {
		"name": "Cédric Delpoux",
		"email": "xuopled@gmail.com"
	},
	"description": "A lightweight responsive bar chart component for React using SVG",
	"files": [
		"es",
		"lib",
		"umd"
	],
	"homepage": "https://github.com/xuopled/react-svg-bar-chart#readme",
	"keywords": [
		"react",
		"bar",
		"chart",
		"barchart",
		"responsive",
		"svg"
	],
	"license": "MIT",
	"main": "lib/index.js",
	"module": "es/index.js",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/xuopled/react-svg-bar-chart.git"
	},
	"scripts": {
		"build": "nwb build-react-component",
		"clean": "nwb clean-module && nwb clean-demo",
		"deploy": "gh-pages -d demo/dist",
		"lint": "eslint src demo/src",
		"precommit": "lint-staged",
		"prepublish": "yarn run clean && yarn run build",
		"start": "nwb serve-react-demo --port 1190",
		"test": "jest --config jest.config.json --colors --no-cache",
		"test:watch": "yarn test -- --watch"
	},
	"dependencies": {
		"styled-components": "^2.1.2"
	},
	"devDependencies": {
		"babel-eslint": "^7.2.3",
		"babel-jest": "^20.0.3",
		"babel-plugin-transform-object-rest-spread": "^6.26.0",
		"babel-preset-env": "^1.6.1",
		"babel-preset-react": "^6.24.1",
		"enzyme": "^2.9.1",
		"eslint": "^4.5.0",
		"eslint-config-prettier": "^2.3.0",
		"eslint-loader": "^1.9.0",
		"eslint-plugin-jest": "^20.0.3",
		"eslint-plugin-prettier": "^2.1.2",
		"eslint-plugin-react": "^7.3.0",
		"gh-pages": "^1.0.0",
		"html-loader": "^0.5.1",
		"husky": "^0.14.3",
		"jest": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"lint-staged": "^4.0.2",
		"markdown-loader": "^2.0.2",
		"nwb": "^0.18.0",
		"prettier": "^1.5.3",
		"prop-types": "^15.6.0",
		"react": "^15.6.1",
		"react-demo-page": "^0.3.4",
		"react-dom": "^15.6.1",
		"react-test-renderer": "^15.6.1"
	},
	"peerDependencies": {
		"react": "^15.0.0 || ^16.0.0",
		"react-dom": "^15.0.0 || ^16.0.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = ./package.json
// module chunks = 0